import qs from "qs";
import configure, { apiUrls } from '@/constant/configure';
import api from "@/helpers/api_helper";

export const getChatShortLink = async (userId: string,) => {
    try {
        return await api.get(`/users/${userId}/short-link`, { baseURL: apiUrls.chat2 })
    } catch (error) { throw error }
}

export const getIsUnreadChat = async (mallUserId: string, targetId?: string, roomType:'SELLER'|'USER' = 'SELLER') => {
    try {
        return await api.get(
            // `/rooms/messages/unread?userId=${mallUserId}`,
            `/rooms/messages/unread?userId=${mallUserId}${!!targetId ? `&opponentUserId=${targetId}` : ''}&roomType=${roomType}`,
            { baseURL: apiUrls.chat2 }
        ).then(r => {
            return r.data
        })
    } catch (error) { return false }
}